export default __webpack_public_path__ + "static/media/emoticon.986c2fbd.svg";